module.exports = __webpack_public_path__ + "static/img/m4.9e2fda1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-edge/mobile/m4.png
// module id = Ef2O
// module chunks = 12